import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Diya from "./Diya";

/** A trail of glowing diyas that gently travel with the visitor's scroll. */
const DIYAS = [
  { side: "left", offset: "2%", size: 64, out: 1500, rot: -6, delay: 0 },
  { side: "left", offset: "6%", size: 44, out: 1100, rot: 8, delay: 0.9 },
  { side: "left", offset: "1%", size: 52, out: 2100, rot: 4, delay: 1.7 },
  { side: "right", offset: "3%", size: 72, out: 1400, rot: -8, delay: 0.4 },
  { side: "right", offset: "7%", size: 46, out: 2000, rot: 10, delay: 1.2 },
  { side: "right", offset: "2%", size: 56, out: 2600, rot: -4, delay: 2.1 },
];

function FloatingOne({ cfg, scrollY }) {
  const y = useTransform(scrollY, [0, 4200], [0, cfg.out]);
  const rotate = useTransform(scrollY, [0, 4200], [cfg.rot, -cfg.rot]);
  const pos = cfg.side === "left" ? { left: cfg.offset } : { right: cfg.offset };
  return (
    <motion.div
      aria-hidden="true"
      style={{ y, rotate, ...pos }}
      className="pointer-events-none fixed top-24 z-30 hidden opacity-80 md:block"
    >
      <div className="float-y" style={{ animationDelay: `${cfg.delay}s` }}>
        <Diya size={cfg.size} className="drop-shadow-[0_0_24px_rgba(245,158,11,0.5)]" />
      </div>
    </motion.div>
  );
}

export default function FloatingDiyas() {
  const { scrollY } = useScroll();
  const yMobile = useTransform(scrollY, [0, 4000], [0, 1400]);
  return (
    <>
      {DIYAS.map((cfg, i) => <FloatingOne key={i} cfg={cfg} scrollY={scrollY} />)}
      {/* single small diya on mobile */}
      <motion.div data-testid="floating-diya" aria-hidden="true" style={{ y: yMobile }}
        className="pointer-events-none fixed right-3 top-24 z-30 opacity-90 md:hidden">
        <div className="float-y"><Diya size={42} className="drop-shadow-[0_0_18px_rgba(245,158,11,0.55)]" /></div>
      </motion.div>
    </>
  );
}
